/* Функции */
import {
  defineComponent, PropType, VNode,
} from 'vue'

/** Типы */
import { defaultProps, defaultStyles } from '@/components/VText/Types'

/* Стили */
import '@/components/VText/VTextHeadingPagePromo/VTextHeadingPagePromo.scss'

export default defineComponent({
  name: 'VTextHeadingPagePromo',

  props: {
    ...defaultProps(),

    /** Тег */
    tag: {
      type: String as PropType<string>,
      default: 'h1',
    },
  },

  computed: {
    styles() {
      return {
        ...defaultStyles.call(this),
      }
    },
  },

  render(): VNode {
    const nameComponent = this.tag

    return (
      <nameComponent onClick={this.onClick} class={'text text-heading-page-promo'} style={this.styles}>
        {this.$slots.default?.()}
      </nameComponent>
    )
  },
})
